export const libraryEndpoints = {
    blended: {
        bulkDeliverables: {
            api: '/api/library/blended/deliverable/bulk',
            method: 'GET',
            parameter: true
        }
    },
    content: {
        assessment: {
            add: {
                api: '/api/library/content/assessment',
                method: 'POST',
                parameter: false
            }
        },
        list: {
            api: '/api/library/content',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/library/content/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/library/content/add',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/content/add/admin',
                method: 'POST',
                parameter: false
            }
        },
        edit: {
            api: '/api/library/content/edit',
            method: 'POST',
            parameter: false
        },
        validate: {
            api: '/api/library/content/validate',
            method: 'GET',
            parameter: true
        },
        nameValidation: {
            api: '/api/library/content/name/check',
            method: 'GET',
            parameter: true
        }
    },
    configuration: {
        list: {
            api: '/api/library/config',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/library/config/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/library/config/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/library/config/update',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/config/edit/admin',
                method: 'POST',
                parameter: false
            }
        },
        popularLanguages: {
            api: '/api/library/config/dictionary/popular-languages',
            method: 'GET',
            parameter: false
        },
        otherLanguages: {
            api: '/api/library/config/dictionary/other-languages',
            method: 'GET',
            parameter: false
        }
    },
    deliverable: {
        list: {
            api: '/api/library/deliverable',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/library/deliverable/details',
            method: 'GET',
            parameter: true
        },
        edit: {
            api: '/api/library/deliverable/edit',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/deliverable/edit/admin',
                method: 'POST',
                parameter: false
            }
        },
        add: {
            api: '/api/library/deliverable/add',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/deliverable/add/admin',
                method: 'POST',
                parameter: false
            }
        },
        addContent: {
            api: '/api/library/deliverable/content',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/deliverable/content/admin',
                method: 'POST',
                parameter: false
            }
        },
        fileUpload: {
            api: '/api/library/deliverable/file',
            method: 'POST',
            parameter: false
        },
        deliverableType: {
            api: '/api/library/deliverable/compatible',
            method: 'GET',
            parameter: true
        },
        nameValidation: {
            api: '/api/library/deliverable/name/check',
            method: 'GET',
            parameter: true
        },
        validateThumbnail: {
            api: '/api/library/thumbnail/validate',
            method: 'POST',
            parameter: true
        }
    },
    productContent: {
        list: {
            api: '/api/library/productcontent',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/library/productcontent/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/library/productcontent/add',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/productcontent/add/admin',
                method: 'POST',
                parameter: false
            }
        },
        edit: {
            api: '/api/library/productcontent/edit',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/productcontent/edit/admin',
                method: 'POST',
                parameter: false
            }
        },
        addProductContentDeliverable: {
            api: '/api/library/productcontent/deliverable',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/productcontent/deliverable/admin',
                method: 'POST',
                parameter: false
            }
        },
        activateProductContentDeliverable: {
            api: '/api/library/productcontent/activate',
            method: 'POST',
            parameter: false
        }
    },
    printSpecification: {
        list: {
            api: '/api/library/printspecification',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/library/printspecification/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/library/printspecification/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/library/printspecification/edit',
            method: 'POST',
            parameter: false
        }
    },
    dictionary: {
        contentDictionaryByType: {
            api: '/api/library/content/dictionary/byType',
            method: 'GET',
            parameter: true
        },
        contentType: {
            api: '/api/library/config/type/contenttype',
            method: 'GET',
            parameter: false
        },
        deliverableType: {
            api: '/api/library/config/type/deliverabletype',
            method: 'GET',
            parameter: false
        },
        internalRepositoryType: {
            api: '/api/library/config/type/internalrepositorytype',
            method: 'GET',
            parameter: false
        },
        agoraValues: {
            api: '/api/library/config/dictionary/agoravalues',
            method: 'GET',
            parameter: true
        },
        status: {
            api: '/api/library/config/type/status',
            method: 'GET',
            parameter: false
        },
        compatibleContent: {
            api: '/api/library/dictionary/compatible/content',
            method: 'GET',
            parameter: true
        },
        language: '/api/library/config/type/language',
        brandingLevel: '/api/library/config/type/brandlevel',
        coverType: '/api/library/config/type/covertype',
        orientation: '/api/library/config/type/orientation',
        binding: '/api/library/config/type/binding',
        paperType: '/api/library/config/type/papertype',
        productVariant: '/api/library/config/type/productvariant',
        printSpecification: '/api/library/printspecs',
        content: '/api/library/content/dictionary',
        configurationType: '/api/library/config/type/types',
        deliverable: '/api/library/deliverable/dictionary',
        productContentDeliverable: '/api/library/productcontent/deliverables',
        deliverableContent: '/api/library/deliverable/contentlist',
        detailsDeliverables: '/api/library/content/deliverables',
        detailsDeliverableProduct: '/api/library/deliverable/products',
        getDomainDict: '/api/library/domain/list',
        getContentTypeDict: '/api/library/config/type/contenttype',
        getStatusDict: '/api/library/config/type/status',
        getLanguageDict: '/api/library/config/type/language',
        getBrandingLevelDict: '/api/library/config/type/brandlevel',
        getCoverTypeDict: '/api/library/config/type/covertype',
        getOrientationDict: '/api/library/config/type/orientation',
        getBindingDict: '/api/library/config/type/binding',
        getPaperTypeDict: '/api/library/config/type/papertype',
        getProductVariantDict: '/api/library/config/type/productvariant',
        getPrintSpecificationDict: '/api/library/printspecs',
        getContentDict: '/api/library/content/dictionary',
        getContentDictAdmin: '/api/library/content/dictionary/admin',
        getConfigurationTypeDict: '/api/library/config/type/types',
        getDeliverableDict: '/api/library/deliverable/dictionary',
        getDeliverableDictAdmin: '/api/library/deliverable/dictionary/admin',
        getProductContentDeliverables: '/api/library/productcontent/deliverables',
        getInternalRepositoryDeliverables: '/api/library/internal/repository/deliverables',
        getProductContentDeliverablesBySkuLibrary: '/api/library/productcontent/deliverables/sku',
        //TODO: remove line in future
        getProductContentDeliverablesBySku: '/api/solar/productcontent/deliverables/sku',
        getDeliverableContent: '/api/library/deliverable/contentlist',

    },
    preview: {
        branded: {
            api: '/api/library/preview/branded',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/library/preview/delete',
            method: 'POST',
            parameter: false
        }
    },
    presentation: {
        empty: {
            api: '/api/library/presentations/empty',
            method: 'POST',
            parameter: false
        },
        options: {
            api: '/api/library/presentation-covers',
            method: 'GET',
            parameter: false
        }
    },
    internalRepository: {
        list: {
            api: '/api/library/internalrepository',
            method: 'GET',
            parameter: false
        },
        checkVariantByName: {
            api: '/api/library/internal/repository/namecheck',
            method: 'GET',
            parameter: true
        },
        checkByName: {
            api: '/api/library/internal/repository/parent/namecheck',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/library/internalrepository/details',
            method: 'GET',
            parameter: true
        },
        fullDetailsById: {
            api: '/api/library/internal/repository/parent/contents/byid',
            method: 'GET',
            parameter: false
        },
        fullDetailsBySKU: {
            api: '/api/library/internal/repository/contents/bysku',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/library/internalrepository/add',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/internalrepository/add/admin',
                method: 'POST',
                parameter: false
            }
        },
        edit: {
            api: '/api/library/internalrepository/edit',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/internalrepository/edit/admin',
                method: 'POST',
                parameter: false
            },
        },
        editBySku: {
            api: '/api/library/internal/repository/parent/edit/bysku',
            method: 'POST',
            parameter: false
        },
        dictionary: {
            api: '/api/library/internalrepository/dictionary',
            method: 'GET',
            parameter: false
        },
        dictionaryExcludeList: {
            api: '/api/library/internal/repository/parent/dictionary/excludelist',
            method: 'GET',
            parameter: false
        },
        addProductContentDeliverable: {
            api: '/api/library/internalrepository/deliverable',
            method: 'POST',
            parameter: false,
            admin: {
                api: '/api/library/internalrepository/deliverable/admin',
                method: 'POST',
                parameter: false
            }
        },
        activateProductContentDeliverable: {
            api: '/api/library/internalrepository/activate',
            method: 'POST',
            parameter: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/library.endpoints.ts